import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "dialog", "image", "prevButton", "nextButton" ]

  connect() {
    // Encontra todos os links de imagem dentro deste controller
    this.imageLinks = this.element.querySelectorAll("[data-action='click->lightbox#open']")
    this.currentIndex = 0 // Inicializa o índice
  }

  open(event) {
    event.preventDefault()
    const imageUrl = event.currentTarget.href

    // Encontra o índice da imagem clicada
    this.imageLinks.forEach((link, index) => {
      if (link.href === imageUrl) {
        this.currentIndex = index
      }
    })

    this.showImage(imageUrl)
    this.dialogTarget.showModal() // Abre o pop-up
    this.updateButtonVisibility() // Atualiza os botões
  }

  close() {
    this.dialogTarget.close() // Fecha o pop-up
  }

  next() {
    if (this.currentIndex < this.imageLinks.length - 1) {
      this.currentIndex++
      const nextImageUrl = this.imageLinks[this.currentIndex].href
      this.showImage(nextImageUrl)
      this.updateButtonVisibility()
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--
      const prevImageUrl = this.imageLinks[this.currentIndex].href
      this.showImage(prevImageUrl)
      this.updateButtonVisibility()
    }
  }

  showImage(url) {
    this.imageTarget.src = url // Troca a imagem no pop-up
  }

  updateButtonVisibility() {
    // Esconde o botão "anterior" se for a primeira imagem
    this.prevButtonTarget.classList.toggle('hidden', this.currentIndex === 0)
    // Esconde o botão "próximo" se for a última imagem
    this.nextButtonTarget.classList.toggle('hidden', this.currentIndex === this.imageLinks.length - 1)
  }

  // Permite fechar o dialog clicando fora da imagem
  closeOnBackdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
